import { Button, type ButtonProps, Text } from "@pamperedchef/design-system";
import type { HeadingTag } from "@/app/utilities/types";

import { PartyItem, PartyItemProps } from "./PartyItem";
import * as styles from "./PartyList.module.scss";

export interface PartyListProps {
	headline?: string;
	headlineTag?: HeadingTag;
	items?: PartyItemProps[];
	hasMoreItems?: boolean;
	cta?: ButtonProps;
	onListSelect?: (id: string | null) => void;
	onLoadMore?: () => void;
}

/**
 * PartyList component
 */
export function PartyList({
	headline,
	headlineTag = "h3",
	items,
	hasMoreItems,
	cta,
	onListSelect,
	onLoadMore
}: PartyListProps): JSX.Element {
	return (
		<div className={styles["party-list"]}>
			<Text styledAs="mdb" tag={headlineTag}>
				{headline}
			</Text>

			<ul className={styles["party-list__listing"]}>
				<div className={`grid ${styles["party-grid"]}`}>
					{items?.map((item, index) => {
						const isLastElement =
							index === items?.length - 1 ||
							index === items?.length - 2;

						return (
							<div
								key={`${item.hostName}-${index}`}
								className="col-xs-12 col-lg-6"
							>
								<PartyItem
									{...item}
									isLastElement={isLastElement}
									onSelect={onListSelect}
								/>
							</div>
						);
					})}
				</div>
			</ul>

			{cta && hasMoreItems && (
				<div className={styles["party-list__cta"]}>
					<Button
						{...cta}
						kind="secondary"
						size="lg"
						surface="default"
						icon={{ name: "ChevronDown", position: "right" }}
						onClick={() => onLoadMore?.()}
					/>
				</div>
			)}
		</div>
	);
}
